import request from '@/utils/analyticsRequest'

export function listProspects(params) {
  return request({ url: '/api/v1/ghl/prospects', method: 'get', params })
}
